import React, { Component } from 'react'
import sleep from '../../sleep'
import ScrollAnimation from 'react-animate-on-scroll'
import { Spring, Trail, Keyframes, animated, config, template } from 'react-spring'
import { TimingAnimation, Easing } from 'react-spring/dist/addons.cjs'
import './_intro.scss'

class Intro extends Component {
  constructor() {
    super()
    this.state = { items: ['CetraRuddy DNA', '6 stories', '1 vision'] }
  }

  async componentDidMount() {
    await sleep(1000)
    await this.content(Trail, { from: { x: -100, opacity: 0 }, to: { x: 50, opacity: 1 } })
    await sleep(1000)
    
    setTimeout(() => {
      this.props.handleIntroExit(true)
      document.querySelector('.intro').classList.add('animated', 'fadeOut')
    }, 2250)
  }

  render() {
    const { items } = this.state
    const isIE = /*@cc_on!@*/ false || !!document.documentMode
    if (isIE) {
      return (
				<div className='ie intro'>
					<div className='ie box'>
						<h2>CetraRuddy DNA</h2>
					</div>
					<div className='ie box'>
						<h2>6 Stories</h2>
					</div>
					<div className='ie box'>
						<h2 className='ie yellow'>1 Vision</h2>
					</div>
				</div>
			)
    } else {
      return (
        <div className="intro">
          <Keyframes
            native
            keys={items}
            config={{ delay: 200, duration: 1000, easing: Easing.linear }}
            impl={TimingAnimation}
            script={next => (this.content = next)}>
            {items.map(item => ({ x, ...props }) => (
              <animated.div
                style={{ transform: x.interpolate(x => `translate3d(${x}vw,0,0)`), ...props }}
                className="box">
                <h2 className={item === '1 vision' ? 'yellow' : ''}>{item}</h2>
              </animated.div>
            ))}
          </Keyframes>
        </div>
      )
    }
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/components/intro/index.js